let { cut } = require('../../../../../../helpers/utils');
let css = require('./tree-input.css');
let signals = require('../../../../../../signals/custom-order');
let Tooltip = require('./tree-input-tooltip');

class TreeInput {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }, this.$context.props));
    }

    bind () {
        return {
            click: {
                [cut(css.filterButton)]: this.uploadTreeValues,
                [cut(css.downloadButton)]: this.downloadList
            }
        };
    }

    uploadTreeValues (e) {
        e.stopPropagation();
        let treeInputId = e.currentTarget.attributes['cat-id'].value;
        let treeInputUnrecognizedId = e.currentTarget.attributes['cat-id-unrecognized'].value;
        let treeInput = document.getElementById(treeInputId).value;

        let inputUnrecognized = document.getElementById(treeInputUnrecognizedId);
        if (inputUnrecognized) {
            treeInput = treeInput.concat('\n', inputUnrecognized.value);
        }

        this.$context.signal(signals.uploadTreeInputCities,
            { treeInput, treeInputId, treeId: this.$context.props.treeId, basePath: this.$context.props.basePath });
    }

    downloadList (e) {
        e.stopPropagation();
        this.$context.signal(signals.downloadCitiesFile);
    }
}

module.exports = {
    constructor: TreeInput,
    children: [
        {
            name: 'tooltip',
            component: Tooltip,
            watcher: {
                haveUnrecognized: ['order', 'computed', 'treeUpload', 'cities', 'haveUnrecognized'],
                recognizeAll: ['order', 'treeUpload', 'cities', 'recognizeAll']
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./components/common/custom-order/cities/content/tree-input/index.js